import { useAtomValue } from "jotai";

import Car from "components/Car";
import Flex from "components/Flex";

import { clientConfigAtom } from "atoms/clientConfig";
import { CarPart } from "types/CarPart";
import { Estimate } from "types/Estimate";

import { PartOperation } from "./PartOperation";
import { Prices } from "./Prices";

type DamagedPartsEstimateProps = {
  estimate: Estimate;
};

export const DamagedPartsEstimate = ({ estimate }: DamagedPartsEstimateProps) => {
  const { estimate: estimateConfig, enablePayeeJourney } = useAtomValue(clientConfigAtom);
  const showDamagedPartList = estimateConfig?.repairable?.showDamagedPartList ?? true;
  const showDamagePartsPrice = estimateConfig?.repairable?.showDamagedPartListCosts ?? false;

  const { damagedParts, totalIncludingTax, totalExcludingTax, breakdown } = estimate;
  const displayEstimate = estimateConfig?.repairable?.showBreakdown || estimateConfig?.repairable?.showTotalPrice || enablePayeeJourney;
  return (
    <Flex>
      {displayEstimate && (
        <Prices totalExcludingTax={totalExcludingTax} totalIncludingTax={totalIncludingTax} breakdown={breakdown} />
      )}
      <Flex align="center" my={32}>
        <Car damagedParts={damagedParts} />
      </Flex>
      {showDamagedPartList && (
        <Flex as="ul">
          {Object.entries(damagedParts).map(([part, { operation, replacementPartCost}]) => {
            const partOperationProps= {
              part: part as CarPart,
              operation: operation,
              replacementPartCost: showDamagePartsPrice ? replacementPartCost : undefined,
            }

            return <PartOperation key={part} {...partOperationProps} />
          })}
        </Flex>
      )}
    </Flex>
  );
};
